import Vue from 'vue';
import Vuex from 'vuex';
// import createLogger from 'vuex/dist/logger';
// import getters from './getters';

Vue.use(Vuex);

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
// eslint-disable-next-line no-shadow
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  let moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  let splitNameList = moduleName.split('-');
  if (splitNameList.length > 1) {
    splitNameList = splitNameList.map((item, index) => {
      if (index) {
        return item.charAt(0).toUpperCase() + item.slice(1);
      }
      return item;
    });
    moduleName = splitNameList.join('');
  }
  modules[moduleName] = value.default;

  return modules;
}, {});

// const IS_PROD = process.env.NODE_ENV === 'production';

const store = new Vuex.Store({
  modules,
  // getters,
  // plugins: IS_PROD ? [] : [createLogger()],
});

export default store;
